(function () {
    'use strict';

    angular.module('PWAPoCApp').factory('routeStopsMessageService', routeStopsMessageService);

    routeStopsMessageService.$inject = ['$rootScope', 'messagesService', '$kWindow', 'translateService', 'messageState'];

    function routeStopsMessageService($rootScope, messagesService, $kWindow, translateService, messageState) {

        var routeStopsMessageService = {
            showRouteStopMessage: showRouteStopMessage,
        };

        function showRouteStopMessage(routeStop) {
            routeStop.agreementLines.forEach((agreementLine) => {
                messagesService
                    .getAllRouteStopMessages(agreementLine.agreementId)
                    .then(function (messages) {
                        if (!messages?.length) return;
                        messages.forEach((message) => {
                            if (message.messageState === 0) {
                                $kWindow.open({
                                    options: {
                                        modal: true,
                                        title: translateService.translate(
                                            "directMessage.messages"
                                        ),
                                        draggable: false,
                                        movable: false,
                                        resizable: false,
                                        visible: false,
                                        height: 250,
                                        width: 350,
                                        close: function () {
                                            readMessage(message);
                                        },
                                    },
                                    templateUrl:
                                        "app/routeStops/modals/route-stop-message-view.html",
                                    windowTemplateUrl:
                                        "app/shared/modal-base.html",
                                    controller: "RouteStopMessageController",
                                    resolve: {
                                        message: function () {
                                            return message;
                                        },
                                    },
                                });
                                var audio = new Audio(
                                    "sounds/message-notification.mp3"
                                );
                                audio.play();
                            }
                        });
                    });
            });
        }

        function readMessage(message) {
            if (message.messageState === messageState.new) {
                messagesService.updateMessageStatus(message.id).then(function () {
                    message.messageState = messageState.readProfile;
                    $rootScope.messageBadgeCount--;

                    if ($rootScope.messageBadgeCount === 0) {
                        $rootScope.showMessageBadge = false;
                    }
                });
            }
        }

        return routeStopsMessageService;

    }
})();
